import { Yup } from "lib/yup/extendYup";

export const userInfoValidationSchema = Yup.object().shape({
  firstName: Yup.string().max(50).required("First name is required"),
  lastName: Yup.string().max(50).required("Last name is required"),
  email: Yup.string().email().required("Email is required"),
  employeeId: Yup.string().required("Employee ID is required"),
  roleId: Yup.string().required("Select user's role"),
});
